const initialState = {
    isLoad: false,
    ordersData: null,
    totalOrdersCount: 0,
    filters: {},
    childPartners: [],
};

export default initialState;
